import de from './de.json';
import en from './en.json';

export default {
  de: { translations: de },
  en: { translations: en }
};
